import { render, staticRenderFns } from "./FightersSlider.vue?vue&type=template&id=c505ea9c&lang=pug&"
import script from "./FightersSlider.vue?vue&type=script&lang=js&"
export * from "./FightersSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports